/**
 * Created by Administrador on 06/09/2017.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('luggageRules', {
                parent: 'app',
                url: '/luggageRules',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                params: {
                    page: "0",
                    size: "10"
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/configGeneral/rates/luggageRule/luggageRules.html',
                        controller: 'luggageRulesCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['luggageRule']);
                            }],
                            luggageRules: ['luggageRuleService','$stateParams',function(luggageRuleService,$stateParams){
                                return luggageRuleService.getLuggageRules($stateParams.page, $stateParams.size, true);
                            }]
                        }
                    }
                }
            })
            .state('luggageRuleNew', {
                parent: 'app',
                url: '/luggageRule/new',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/configGeneral/rates/luggageRule/newEditLuggageRule.html',
                        controller: 'newEditLuggageRuleCtrl',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['translationHandler', function (translationHandler) {
                        return translationHandler.translateRefresh(['luggageRule','passengerType']);
                    }],
                    action: [function() {
                        return "new";
                    }],
                    luggageRule: [function(){
                        return null;
                    }],
                    segments: ['stretchService', function(stretchService){
                        return stretchService.getStretches();
                    }],
                    excessLuggageTypes: ['excessLuggageTypeService', function(excessLuggageTypeService){
                        return excessLuggageTypeService.getExcessLuggageTypes();
                    }]
                }
            })
            .state('luggageRuleEdit', {
                parent: 'app',
                url: '/luggageRule/:id/edit',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/configGeneral/rates/luggageRule/newEditLuggageRule.html',
                        controller: 'newEditLuggageRuleCtrl',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['translationHandler', function (translationHandler) {
                        return translationHandler.translateRefresh(['luggageRule','passengerType']);
                    }],
                    action: [function() {
                        return "edit";
                    }],
                    luggageRule: ['luggageRuleService','$stateParams', function(luggageRuleService,$stateParams){
                        return luggageRuleService.getLuggageRule($stateParams.id);
                    }],
                    segments: ['stretchService', function(stretchService){
                        return stretchService.getStretches();
                    }],
                    excessLuggageTypes: ['excessLuggageTypeService', function(excessLuggageTypeService){
                        return excessLuggageTypeService.getExcessLuggageTypes();
                    }]
                }
            })
            .state('luggageRuleDelete', {
                parent: 'luggageRules',
                url: '/luggageRule/:id/delete',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/configGeneral/rates/luggageRule/deleteLuggageRule.html',
                        controller: 'deleteLuggageRuleController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            'luggageRuleId': [function() {
                                return $stateParams.id
                            }],
                            'luggageRule': ['luggageRuleService', function(luggageRuleService) {
                                return luggageRuleService.getLuggageRule($stateParams.id)
                            }]
                        }
                    }).result.then(function() {
                        $state.go('luggageRules', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
    }
})();
